import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../redux/authSlice";
import commonReducer from "../redux/commonSlice";
import crudReducer from "../redux/crudSlice";
import profileReducer from '../redux/profileSlice';
import globalStateReducer from "../redux/globalStateSlice";
import awaitedSurfaceReducer from '../redux/awaitedSurfacesSlice';
import chitraReducer from "../modules/reports/chitraSlice";
export var store = configureStore({
    reducer: {
        common: commonReducer,
        auth: authReducer,
        crud: crudReducer,
        profile: profileReducer,
        globalState: globalStateReducer,
        modal: awaitedSurfaceReducer,
        chitra: chitraReducer
    }
});
